module.exports = __webpack_public_path__ + "static/media/goat-in-leather-jacket.8236e39b.gif";